<template>
<div class="dboard-card dboard-card-min">
  <loading-progress
    v-if="isLoading"
    :progress="60"
    :indeterminate=true
    :hide-background="true"
    size="64"
    rotate
    fillDuration="2"
    rotationDuration="1"
  />
  <div v-else>
    <div class="row row-space">
      <div class="col-lg-12">
      <div class="dboard-card-title">
        Average TAT at Pickup
      </div>
      <div class="dboard-card-panel" v-if="sla">
        <div class="dboard-card-panel-section w100p">
          <div class="dboard-card-section-primarynumber primary-text dsplinline">
            {{Number(sla.average_pickup_time.current).toFixed(2)}} hrs
          </div>
          <div class="count" v-if="sla.average_pickup_time.previous">
            <div v-if="isDown" class="dboard-card-section-tertiarynumber
            tertiary-text dsplinline-right">
              <svgicon name="countdown"
                class="svg-icon"
                width="10" height="12" :original="true" />
              {{Number(percentage).toFixed(2)}}%
              <span class="info">From last month</span>
            </div>
            <div v-else class="dboard-card-section-tertiarynumber
            tertiary-text dsplinline-right countup">
              <svgicon name="countup"
                class="svg-icon"
                width="10" height="12" :original="true" />
              {{Number(percentage).toFixed(2)}}%
              <span class="info">From last month</span>
            </div>
         </div>
        </div>
      </div>
    </div>
    </div>
    <div class="row row-space" v-if="!isLoading">
      <div class="col-lg-12">
        <div class="tat-text">
          Trucks with TAT
        </div>
        <div class="tat-rect">
          <div class="tat-border-container">
            <div class="tat-border-child">
              <div class="tat-rect-text tat-rect-text-6h">
                6H
              </div>
              <div class="tat-dashed">
              </div>
            </div>
            <div class="tat-border-child">
              <div class="tat-rect-text tat-rect-text-12h">
                12H
              </div>
              <div class="tat-dashed">
              </div>
            </div>
            <div class="tat-border-child">
              <div class="tat-rect-text tat-rect-text-24h">
                24H
              </div>
              <div class="tat-dashed">
              </div>
            </div>
            <div class="tat-border-child">
              <div class="tat-dashed">
              </div>
            </div>
          </div>
        </div>
        <div class="percentage-container">
          <div class="percentage-child">
            <div class="percentage-child-text">
              {{Number(h0).toFixed(1)}}%
            </div>
          </div>
          <div class="percentage-child">
            <div class="percentage-child-text">
              {{Number(h6).toFixed(1)}}%
            </div>
          </div>
          <div class="percentage-child">
            <div class="percentage-child-text">
              {{Number(h12).toFixed(1)}}%
            </div>
          </div>
          <div class="percentage-child">
            <div class="percentage-child-text">
              {{Number(h24).toFixed(1)}}%
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 border">
        <div class="dboard-card-title">
          Loading Start
        </div>
        <div class="dboard-card-panel">
          <div class="dboard-card-panel-section">
            <div class="dboard-card-section-primarynumber primary-text">
              {{count.loading_started}}
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="dboard-card-title">
          Loading End
        </div>
        <div class="dboard-card-panel">
          <div class="dboard-card-panel-section">
            <div class="dboard-card-section-primarynumber primary-text delivered-count">
              {{count.loading_ended}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
/* eslint-disable */
export default {
  props: {
    isLoading: {
      type: Boolean,
    },
    count: {
      type: Object,
    },
    sla: {
      type: Object,
    }
  },

  computed: {
    isDown() {
      return this.sla.average_pickup_time.current < this.sla.average_pickup_time.previous;
      // return false;
    },
    percentage() {
      let percentage = 0;
      if (this.isDown) {
        percentage = (this.sla.average_pickup_time.current / this.sla.average_pickup_time.previous) * 100;
      } else {
        percentage = 100 - (this.sla.average_pickup_time.current / this.sla.average_pickup_time.previous) * 100;
      }
      return percentage;
    },
    total() {
      return (this.count.dispatched + this.count.delivered);
    },
    h0() {
      return this.getHValues(0);
    },
    h6() {
      return this.getHValues(6);
    },
    h12() {
      return this.getHValues(12);
    },
    h24() {
      return this.getHValues(24);
    }
  },
  methods: {
    getHValues(h) {
      if (this.sla) {
        let percentage = (this.sla.pickup_distribution[h] / this.total ) * 100;
        return percentage > 0 ? percentage : 0;
      }
      return 0;
    }
  }
}
</script>
<style lang="scss">
.countup {
  color: #72BF1F;
}
.count {
  display: inline;
}
.tat-text {
  color: #CADCFF;
  font-size: 14px;
  line-height: 17px;
}
.tat-rect {
  margin-top: 15px;
  height: 50px;
  width: 100%;
  position: relative;
  background: linear-gradient(82.5deg, #FFF2C5 0%, #FFA3A3 100%);
}
.tat-border-container {
  position: relative;
  width: 100%;
  height:100%;
}
.tat-border-child {
  position: relative;
  display: inline-block;
  height: 100%;
  width: 25%;
  border-right: 1px solid rgba(21,34,48,0.8);
}
.tat-border-child:last-child {
  border-right: none;
  width: 20%;
}
.tat-rect-text {
  position: absolute;
  display: inline-block;
  top: 30%;
  left: 86%;
  height: 17px;
  width: 23px;
  color: #121E2D;
  font-size: 14px;
  line-height: 17px;
  &-6h{
    background: linear-gradient(82.5deg, #FFE1BE 0%, #FFDDBC 100%);
  }
  &-12h{
    background: linear-gradient(82.5deg, #FFCEB5 0%, #FFC9B3 100%);
  }
  &-24h{
    background: linear-gradient(82.5deg, #FFBAAC 0%, #FFB4A9 100%);
  }
}
.tat-dashed  {
  position: absolute;
  display: inline-block;
  height: 60px;
  width: 2px;
  left: 50%;
  border-right: 1px dashed #FFFFFF;
}
.percentage-container {
  height: 20px;
  width: 100%;
  margin-top: 20px;
  position: relative;
}
.percentage-child {
  position: relative;
  display: inline-block;
  height: 100%;
  width: 25%;
  &-text {
    position: absolute;
    color: #CADCFF;
    font-size: 14px;
    line-height: 17px;
    right: 20%;
  }
  &:last-child {
    width: 21%;
  }
}
.dboard-card-min {
  // min-width: 295px;
}
</style>
